import { getTalkbackNumberView } from "../articleSocialShare1280Component/articleSocialShareNew1280";
import { SummaryDataItem, toSummaryBodyText } from "./articleHeader1280AiSummary";
import { getFrontImageUrl } from "../../../../../front/staticServerRendering/frontImage";
import { ImageSize } from "../../../../../constants/imageSizes";

export const WCM_COMMENTS_EVENT = "onWcmCommetnsRecived";

export function shouldRenderArticleSummary(
    summaryData?: SummaryDataItem[],
    summaryUpdateType?: "disabled" | "auto" | "manual"
): boolean {
    return summaryUpdateType !== "disabled" &&
        Array.isArray(summaryData) &&
        summaryData.some((item) => {
            if (!item) {
                return false;
            }

            const title = typeof item.title === "string" ? item.title.trim() : "";
            const body = toSummaryBodyText(item.body).trim();
            return !!(title || body);
        });
}

export const WCM_READ_ALOUD_STATE_EVENT = "onWcmReadAloudState"
export const WCM_READ_ALOUD_REQUEST_EVENT = "onWcmReadAloudRequest"
export const WCM_AI_SUMMARY_STATE_EVENT = "onWcmAiSummaryState"
export const WCM_BEPO_RECOMMENDATIONS_OPEN_EVENT = "onWcmBepoRecommendationsOpen"

export type ReadAloudStateDetail = {
    isOpen: boolean
    isPlaying: boolean
}

export type ReadAloudRequestDetail = {
    action: "open" | "toggle"
}

export type AiSummaryStateDetail = {
    isOpen: boolean
}

export function dispatchAiSummaryState(isOpen: boolean) {
    if (typeof document === "undefined") {
        return
    }
    document.dispatchEvent(new CustomEvent(WCM_AI_SUMMARY_STATE_EVENT, {
        detail: { isOpen } as AiSummaryStateDetail,
    }))
}

export function dispatchBepoRecommendationsOpen() {
    if (typeof document === "undefined") {
        return
    }
    document.dispatchEvent(new CustomEvent(WCM_BEPO_RECOMMENDATIONS_OPEN_EVENT))
}

export function resolveReadAloudData(
    readAloudUrl?: string | null,
    readAloudDuration?: number | null
): { url: string; durationSeconds: number } | null {
    if (readAloudUrl) {
        return {
            url: readAloudUrl,
            durationSeconds: typeof readAloudDuration === "number" ? readAloudDuration : 0,
        }
    }
    return null
}

export function shouldRenderReadAloud(
    readAloudUrl?: string | null,
    readAloudDuration?: number | null
): boolean {
    return !!resolveReadAloudData(readAloudUrl, readAloudDuration)
}

export function formatReadAloudDuration(durationSeconds: number, lang?: string): string {
    const minutes = Math.max(1, Math.ceil(durationSeconds / 60))
    if (lang === "en") {
        return `${minutes} min`
    }
    if (lang === "ru") {
        return `${minutes} мин`
    }
    if (lang === "ar") {
        return `${minutes} دقائق`
    }
    return `${minutes} דקות`
}

 
export function resolveReadAloudMediaImageUrl(promotionImageUrl?: string | null, imagesDomain?: string): string {
    if (!promotionImageUrl) {
        return ""
    }
    if (promotionImageUrl.startsWith("//") || promotionImageUrl.startsWith("http")) {
        return promotionImageUrl
    }
    const frontImageUrl = getFrontImageUrl(
        { publishedLink: promotionImageUrl } as any,
        { imageSize: ImageSize.medium }
    )
    if (!frontImageUrl) {
        return ""
    }
    if (frontImageUrl.startsWith("//") || frontImageUrl.startsWith("http")) {
        return frontImageUrl
    }
    const domain = imagesDomain || ""
    if (!domain) {
        return frontImageUrl.startsWith("/") ? frontImageUrl : `/${frontImageUrl}`
    }
    return frontImageUrl.startsWith("/")
        ? domain + frontImageUrl
        : `${domain}/${frontImageUrl}`
}

export function formatCommentCountMagazine(count: string): string {
    if (!count || count === "0") {
        return "";
    }
    const rawCount = parseInt(count, 10);
    if (rawCount >= 1000) {
        return Math.floor(rawCount / 1000) + "k";
    }
    return count;
}

export function formatCommentCountRegular(count: string): string {
    return getTalkbackNumberView(count);
}

export interface ActionBarLabels {
    commentsText: string;
    noCommentsText: string;
    aiText: string;
}

export function getActionBarLabels(lang?: string, sitename?: string): ActionBarLabels {
    let commentsText = "תגובות";
    let noCommentsText = "תגובה חדשה";
    let aiText = "תקציר AI";

    if (lang === "en") {
        commentsText = "Comments";
        noCommentsText = "New comment";
        aiText = "AI Summary";
    }
    if (lang === "ru") {
        commentsText = "Комментарии";
        noCommentsText = "Новый комментарий";
        aiText = "AI кратко";
    }
    if (lang === "ar" || sitename === "radionas") {
        commentsText = "التعليقات";
        noCommentsText = "تعليق جديد";
        aiText = "ملخص AI";
    }

    return { commentsText, noCommentsText, aiText };
}

export function buildSummaryScriptPayload(
    summaryData?: SummaryDataItem[],
    summaryUpdateType?: "disabled" | "auto" | "manual"
): { summaryData: SummaryDataItem[]; summaryUpdateType: string } {
    return {
        summaryData: Array.isArray(summaryData) ? summaryData : [],
        summaryUpdateType: summaryUpdateType || "disabled",
    };
}
